import styled from "styled-components";

const primary = "var(--primary)";

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) =>
    p.color
      ? p.color
      : "linear-gradient(135deg, rgba(225, 87, 148, 1), rgba(203, 47, 114, 1))"};
  color: ${(p) => (p.color ? primary : "#fff")};
  font-size: 0.98rem;
  font-weight: 700;
  width: 100%;
  letter-spacing: 0.01em;
  border: 1px solid ${(p) => (p.color ? "rgba(225, 87, 148, 0.2)" : "transparent")};
  border-radius: 999px;
  padding: 0.95rem 1.45rem;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 190px;
  transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease,
    border-color 0.25s ease, color 0.25s ease;
  box-shadow: 0 20px 34px rgba(225, 87, 148, 0.22);

  &:hover,
  &:active,
  &:focus-visible {
    color: ${(p) => (p.color ? primary : "#fff")};
    border-color: rgba(225, 87, 148, 0.35);
    background: ${(p) =>
      p.color
        ? "#fff6fa"
        : "linear-gradient(135deg, rgba(214, 63, 129, 1), rgba(180, 38, 96, 1))"};
    transform: translateY(-2px);
    box-shadow: 0 24px 44px rgba(31, 23, 64, 0.16);
  }
`;
